<template>
  <div
    class="popup_wrap"
    style="width:1000px;"
  >
    <button
      style="top: 20px;"
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <form id="mailFrm" style="margin-top: -18px;">
      <div class="popup_cont">
        <h1 class="page_title">{{ couponNm }}</h1>
        <div class="content_box" style="height: 100%;"><!-- content_box -->
          <table>
            <tr>
              <th ref="couponMsg1" style="font-weight: 400; font-size: large;">{{couponMsg1}}</th>
              <th ref="couponMsg2" style="font-size: large; font-weight: 400;">&nbsp;{{couponMsg2}}&nbsp;</th>
              <th ref="couponMsg3" style="font-weight: 400; font-size: large;">{{couponMsg3}}</th>
              <th ref="couponMsg4" style="font-size: large;font-weight: 400; ">&nbsp;{{couponMsg4}}</th>
            </tr>
            <tr v-show="couponMsg5.length > 0">
              <td colspan="4" ref="couponMsg5" style="font-size: medium; font-weight: 400;">{{couponMsg5}}</td>
            </tr>
          </table>
          <div class="content_box" style="padding-top: 7px; height: 100%; background-color: #F0F5FF;">
            <table style="width: 98%; margin-left: 8;">
              <tbody style="border: 0px;">
                <tr>
                    <th style="font-size: smaller; text-align: -webkit-center; background-color: white;" :key="lvlDiv" v-for="(item, lvlDiv) in couponProgressPoint">
                      <!-- <td style="visibility: hidden; border-top: 0px; color: white; background-color: cornflowerblue;">{{ item.progress }}</td> -->
                      <div v-bind:style="{color: item === '●' ? 'red' : '#F0F5FF'}" style="font-size: smaller; text-align: right; border-top: 0px; opacity: 70%; background-color: #F0F5FF;">{{ item }}</div>
                    </th>
                </tr>
              </tbody>
            </table>
            <div class="content_box" style="padding: 7px; margin-top: 0px; height: 100%; background-color: #F0F5FF;">
              <table style="width: 100%;">
                <tbody style="border: 0px;">
                  <tr>
                      <th style="font-size: smaller; text-align: -webkit-center; background-color: #F0F5FF;" :key="lvlDiv" v-for="(item, lvlDiv) in couponProgress">
                        <!-- <td style="visibility: hidden; border-top: 0px; color: white; background-color: cornflowerblue;">{{ item.progress }}</td> -->
                        <div v-bind:style="{visibility: item === '1' ? 'hidden' : 'visible'}" style="height: 24px; text-align: right; border-top: 0px; opacity: 70%; color: rgba(255, 141, 40); background-color: rgba(255, 141, 40);">{{ item }}</div>
                      </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <table style="width: 100%;" class="tbl_list mt10">
              <tbody style="border-left: 2px solid #F0F5FF; border-right: 2px solid #F0F5FF; border-bottom: 2px solid #F0F5FF;">
                <tr style="height: 50px; border-top: 2px solid #F0F5FF;">
                    <th style="border-right: 2px solid #F0F5FF; width: 150px; padding-left: 10px; font-size: large; color: black; background-color: rgba(229, 238, 255);">{{ $t('msg.COUP100.015') }}</th>
                    <th v-show="couponLevelList[0].dcRate !== undefined" style="border-right: 2px solid #F0F5FF; padding-left: 10px; font-size: large; color: black; background-color: rgba(229, 238, 255);">{{ $t('msg.COUP100.016') }}</th>
                    <th style="border-right: 2px solid #F0F5FF; padding-left: 10px; font-size: large; color: black; background-color: rgba(229, 238, 255);">{{ $t('msg.COUP100.017') }}</th>
                    <th style="padding-left: 10px; font-size: large; color: black; background-color: rgba(229, 238, 255);">{{ $t('msg.COUP100.019') }} {{ $t('msg.COUP100.018') }}</th>
                </tr>
                <tr style="height: 50px; border-top: 2px solid #F0F5FF;" :key="lvlDiv" v-for="(item, lvlDiv) in couponLevelList">
                    <th style="border-right: 2px solid #F0F5FF; font-weight: 500; font-size: large; border-top: 0px; color: black; background-color: white;">{{ item.lvlNm }}</th>
                    <th v-show="couponLevelList[0].dcRate !== undefined" style="border-right: 2px solid #F0F5FF; padding-right: 10px; font-weight: 500; text-align: right; font-size: large; border-top: 0px; color: black; background-color: white;">{{ item.dcRate }}%</th>
                    <th style="border-right: 2px solid #F0F5FF; padding-right: 10px; font-weight: 500; text-align: right; font-size: large; border-top: 0px; color: black; background-color: white;">$ {{ item.dc20Max }}/TEU</th>
                    <th style="border-right: 2px solid #F0F5FF; padding-right: 10px; font-weight: 500; text-align: right; font-size: large; border-top: 0px; color: black; background-color: white;">{{ item.targetTeu }} TEU</th>
                </tr>
              </tbody>
            </table>
            <div class="content_box" style="height: 100%; background-color: #F0F5FF;">
              <div class="flex_box ml30">
                <div style="width: 610px;">
                  <li style="font-size: medium;">{{ $t('msg.COUP100.090') }}</li>
                </div>
                <div>
                  <a style="height: 32px; width: 150px;" class="button blue lg ml10" href="#" @click.prevent="promotionLink()">{{ $t('msg.COUP100.038') }}</a><!-- 자세히 보러가기 -->
                </div>
              </div>
            </div>
          </div>
        </div><!-- content_box// -->
      </div>
    </form>
  </div>
</template>

<script>

import { rootComputed } from '@/store/helpers'
import schedule from '@/api/rest/schedule/schedule'

export default {
  name: 'KmtcCouponPromotionPop',
  components: {
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop')
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          couponNm: '',
          couponNo: ''
        }
      }
    }
  },
  data () {
    return {
      couponMsg1: '',
      couponMsg2: '',
      couponMsg3: '',
      couponMsg4: '',
      couponMsg5: '',
      couponNm: '',
      bkgCnt: '',
      nextTargetTeu: '',
      nextLevel: '',
      nextDc20Max: '',
      nextRate: '',
      nextTeu: '',
      params: {
        couponNo: ''
      },
      couponLevelList: [{
        dcRate: ''
      }],
      couponProgress: [],
      couponProgressPoint: []
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    if (this.auth !== undefined) {
      this.lang = this.auth.serviceLang
    }
    this.initParam()

    schedule.getMyCouponLevelList(this.params).then(response => {
      this.couponLevelList = response.data
      let str = this.couponLevelList[0].progress
      let teu = str.substring(0, str.indexOf('/'))
      let maxTeu = str.substring(str.indexOf('/') + 1)

      for (var i = 0; i < maxTeu; i++) {
        if (teu > 0) {
          this.couponProgress.push('0')
        } else {
          this.couponProgress.push('1')
        }
        teu = teu - 1
      }

      for (var k = 0; k < maxTeu; k++) {
        let flag = 0
        for (var j = 0; j < this.couponLevelList.length; j++) {
          if (Number(k + 1) === Number(this.couponLevelList[j].targetTeu)) {
            flag = flag + 1
          }
        }
        if (flag === 0) {
          this.couponProgressPoint.push('0')
        } else {
          this.couponProgressPoint.push('●')
        }
        teu = teu - 1
      }

      this.nextRate = this.couponLevelList[0].nextRate
      this.bkgCnt = this.couponLevelList[0].bkgCnt
      this.nextTargetTeu = this.couponLevelList[0].nextTargetTeu
      this.nextLevel = this.couponLevelList[0].nextLevel
      this.nextDc20Max = this.couponLevelList[0].nextDc20Max

      if (this.couponLevelList[0].dcRate === undefined) {
        this.nextRate = this.nextRate + '/TEU'
      } else {
        this.nextRate = this.nextRate + '%'
      }
      this.nextTeu = this.couponLevelList[0].nextTeu + 'TEU'

      if (this.couponLevelList[0].nextTeu < 1) {
        if (localStorage.getItem('service_ctrcd') === 'KR') {
          this.couponMsg1 = '선적량 달성으로 준비한 최대 할인을 받으실 수 있습니다.'
          this.couponMsg5 = '이용해 주셔서 감사합니다.'
          this.$refs.couponMsg1.style.color = 'black'
        } else {
          this.couponMsg1 = "It's the highest grade, so you can get the maximum discount!"
          this.$refs.couponMsg1.style.color = 'black'
        }
      } else {
        if (localStorage.getItem('service_ctrcd') === 'KR') {
          this.couponMsg1 = this.nextLevel + ' ' + this.nextRate
          this.couponMsg2 = ' 할인쿠폰까지 '
          this.couponMsg3 = this.nextTeu
          this.couponMsg4 = ' 선적이 필요합니다'
          this.couponMsg5 = this.nextLevel + ' 혜택 구분 : ' + this.bkgCnt + ' / ' + this.nextTargetTeu + 'TEU'

          this.$refs.couponMsg1.style.color = 'blue'
          this.$refs.couponMsg2.style.color = 'black'
          this.$refs.couponMsg3.style.color = 'blue'
          this.$refs.couponMsg4.style.color = 'black'
        } else {
          this.couponMsg1 = this.nextTeu
          this.couponMsg2 = ' left until the '
          this.couponMsg3 = this.nextRate
          this.couponMsg4 = ' discount coupon'

          this.$refs.couponMsg1.style.color = 'black'
          this.$refs.couponMsg2.style.color = 'blue'
          this.$refs.couponMsg3.style.color = 'black'
          this.$refs.couponMsg4.style.color = 'blue'
        }
      }
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    // init parameter
    async initParam () {
      this.couponNm = this.parentInfo.couponNm
      this.params.couponNo = this.parentInfo.couponNo
    },
    promotionLink () {
      // this.$router.push('/common/promotion')
      window.location.href = `/${window.location.hostname === 'localhost' ? '' : 'index.html'}#/common/promotion?messageIdSeq=P${this.auth.userCtrCd === 'JP' ? 'JA' : this.auth.userCtrCd}${this.parentInfo.couponNo}&groupId=${this.parentInfo.couponNo}`
      window.location.reload()
      //http://localhost:8080/#/common/promotion?messageIdSeq=CKRCP20241016001&groupId=CP20241016001
      //http://localhost:8080/#/common/pds?messageIdSeq=CKR442&groupId=442
    }
  }
}
</script>

<style scoped>
  .tbl_search th {vertical-align: top;}

  .content_box {border-color: #C7DAFF;}
</style>
